import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-reset-mfa-modal',
  templateUrl: './reset-mfa-modal.component.pug',
  styleUrls: ['./reset-mfa-modal.component.scss'],
  standalone: false
})
export class ResetMfaModalComponent {
  selection = new Subject<boolean>();

  constructor(public bsModalRef: BsModalRef) {}

  cancel() {
    this.bsModalRef?.hide();
  }

  reset() {
    this.bsModalRef?.hide();
    this.selection.next(true);
  }
}
